import { useTranslation } from 'react-i18next';

export default function CTASection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full py-24 md:py-32 px-4 md:px-10 bg-background-50">
      <div className="max-w-5xl mx-auto flex flex-col items-center text-center">
        <div className="w-full rounded-3xl overflow-hidden mb-12">
          <div className="aspect-[16/7] w-full">
            <img
              src="https://readdy.ai/api/search-image?query=Cinematic%20overhead%20flat%20lay%20photography%20of%20carefully%20curated%20fashion%20essentials%20including%20a%20leather%20journal%2C%20vintage%20brass%20compass%2C%20silk%20pocket%20square%2C%20and%20artisanal%20sunglasses%20arranged%20on%20a%20weathered%20wooden%20surface%2C%20dramatic%20window%20light%20from%20upper%20left%20creating%20painterly%20chiaroscuro%20effect%2C%20old%20world%20explorer%20aesthetic%20with%20rich%20cognac%20amber%20and%20deep%20mahogany%20tones%2C%20refined%20editorial%20storytelling%20composition&width=1400&height=600&seq=kg-cta-visual-v2&orientation=landscape"
              alt="Kakobuy Spreadsheet"
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 leading-snug max-w-3xl mb-4">
          {t('cta.heading_line1')}
        </h2>
        <p className="text-xl md:text-2xl text-foreground-500 font-light leading-relaxed max-w-3xl mb-2">
          {t('cta.heading_line2')}
        </p>
        <p className="text-xl md:text-2xl text-foreground-900 font-bold italic leading-relaxed max-w-3xl mb-12">
          {t('cta.heading_line3')}
        </p>

        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-3 px-10 py-4 rounded-full bg-foreground-900 text-background-50 text-base font-semibold hover:bg-foreground-800 transition-all duration-200 whitespace-nowrap cursor-pointer"
        >
          {t('cta.button')}
          <i className="ri-arrow-right-line text-lg"></i>
        </a>
      </div>
    </section>
  );
}